import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'appChatBotAsesorV2Mensaje',
})
export class ChatBotAsesorV2MensajePipe implements PipeTransform {

  transform(value: string): string {
    if (!value) return '';
    const valueReplace = value.replace(/\{document\.\d+\}/g, "");
    return valueReplace;
  }

}
